import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import mascot from "@/assets/alpha-mascot.png";

export default function MascotGuide({ phrases = [], onTalk }) {
  const [visible, setVisible] = useState(false);
  const [idx, setIdx] = useState(0);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 2500);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!visible || phrases.length < 2) return;
    const i = setInterval(() => setIdx((p) => (p + 1) % phrases.length), 5000);
    return () => clearInterval(i);
  }, [visible, phrases.length]);

  if (dismissed || !phrases.length) return null;

  return (
    <div className="fixed bottom-5 right-5 z-40 no-print flex items-end gap-2" data-testid="mascot-guide">
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 0, y: 10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.2 }}
            className="relative mb-4 max-w-[200px] rounded-2xl rounded-br-sm bg-[#1A1A22] border border-gold/25 px-4 py-3 shadow-xl">
            <button onClick={() => setDismissed(true)} data-testid="mascot-guide-close"
              className="absolute -top-2 -right-2 h-6 w-6 rounded-full bg-[#2A2A36] border border-white/10 flex items-center justify-center text-zinc-400 hover:text-white">
              <X size={13} />
            </button>
            <AnimatePresence mode="wait">
              <motion.p key={idx} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
                className="text-sm text-zinc-200 leading-snug">{phrases[idx]}</motion.p>
            </AnimatePresence>
          </motion.div>
        )}
      </AnimatePresence>
      <motion.button
        data-testid="mascot-guide-btn"
        initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: "spring", delay: 2.4 }}
        whileHover={{ scale: 1.06 }} whileTap={{ scale: 0.94 }}
        onClick={onTalk}
        className="h-20 w-20 rounded-full overflow-hidden border-2 border-gold/40 shadow-[0_0_25px_rgba(212,175,55,0.35)] bg-[#0A0A0C]">
        <img src={mascot} alt="Alpha" className="w-full h-full object-cover object-top" />
      </motion.button>
    </div>
  );
}
